import {
  Stack,
  TextField,
  Divider,
  Fade,
  LinearProgress,
  Typography,
  useTheme,
  Button,
  Autocomplete,
  Drawer,
  Box,
  Tooltip,
  Skeleton,
  InputAdornment,
  alpha,
  Checkbox,
  Tabs,
  Tab,
  Popover,
  Slider,
  Alert,
} from "@mui/material";

import {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
  useCallback,
  useMemo,
  useRef,
} from "react";
import {
  parsePolygonFile,
  polygonCentroid,
  IMPORT_POLYGON_COLORS,
  PRECISION_LEVELS,
  DEFAULT_PRECISION,
  getPrecisionLevel,
  resolvePrecision,
} from "../../../utils/easyMaps/kmlParser";
//icons
import TextFieldsIcon from "@mui/icons-material/TextFields";
import EditLocationAltOutlinedIcon from "@mui/icons-material/EditLocationAltOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import { ReactComponent as LinkedIcon } from "../../../assets/easyMaps/iconsSvg/Linked.svg";

import { ReactComponent as ItemIcon } from "../../../assets/easyMaps/iconsSvg/item.svg";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";
import ModalMap from "./modalAddMap";
import IconTransform from "../iconsElement";

import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import NotListedLocationOutlinedIcon from "@mui/icons-material/NotListedLocationOutlined";

import {
  AbcOutlined,
  AutoAwesome,
  BorderColorOutlined,
  CancelOutlined,
  Check,
  CropFree,
  DeleteOutline,
  FormatShapesOutlined,
  HexagonOutlined,
  Link,
  Notes,
  PhotoSizeSelectLargeOutlined,
  TextFields,
  UploadFileOutlined,
  ViewComfy,
  ViewInArOutlined,
  ViewQuilt,
} from "@mui/icons-material";
import PainelIcons from "./painelIcons";
import { VirtualizedListbox } from "../vitualizationAutoComplete";
import useStyles from "./styles";
import { useMapa } from "../../../contexts/mapaContext";
import { v4 as uuidv4 } from "uuid";
import EnlaceSideBarEasyMaps from "../enlaceSidebarEasyMaps";
import NewCardConnection from "./newCardConnection";
import { BaseInfoPopover } from "../infoPopover";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";
import Editor from "@monaco-editor/react";

const PRECISION_MARKS = PRECISION_LEVELS.map(({ id, label }) => ({
  value: id,
  label,
}));

const CreationSliderBarEasyMaps = forwardRef(
  (
    {
      setOpenAlertModal = () => {},
      handleUpdatePositionElement = () => {},
      focusZoomCoordenates = () => {},
      iconsElement,
      setIconsElement,
      socket,
      element,
      produtos = [],
      api,
      maps = [],
      addMapInMaps = () => {},
      fullScreem,
      tipoMapa = 0,
      coordenadasFlow,
      setFocusNodeId = () => {},
      checkChanges,
      setCheckChanges = () => {},
      updateDataElementSocket = () => {},
      deleteElementSocket = () => {},
      centerLeaflatMap = {},
      isPointInBounds = () => {
        return true;
      },
      handleReload = () => {},
      onImportComplete = () => {},
      editMode = false,
      loadRouting,
      setLoadRouting,
      autoRouting,
      cleanRouting,
      changeConnection,
      openEnlaceBar,
      setOpenEnlaceBar,
      hasEnlace = true,
      changeElement,
      setOpenMassEditPolygon = () => {},
    },
    ref,
  ) => {
    const theme = useTheme();
    //variveis default
    const tiposElementos = ["Host", "Mapa", "POP"];
    if (tipoMapa === 0) {
      tiposElementos.push("Texto");
      tiposElementos.push("Área");
    }
    //variaveis do elemento
    const [connectionsElement, setConnectionsElement] = useState([]);
    const [connectionsElementOld, setConnectionsElementOld] = useState([]);
    const [elementName, setElementName] = useState(null);
    const [typeElement, setTypeElement] = useState(null);
    const [productElement, setProductElement] = useState(null);
    const [iconElement, setIconElement] = useState(null);
    const [mapRefElement, setMapRefElement] = useState(null);
    const [coordinatesLat, setCoordinatesLat] = useState(null);
    const [coordinatesLon, setCoordinatesLon] = useState(null);
    //variaveis zabbix
    const [hostsCliente, setHostsCliente] = useState([]);
    const [itensConfig, setItensConfig] = useState([]);
    const [requestSend, setRequestSend] = useState(false);
    const [hostsConfigOld, setHostsConfigOld] = useState([]);
    const [itensHost, setItensHost] = useState([]);
    //outras variaveis

    const [hostsConfig, setHostsConfig] = useState([]);
    const [expanded, setExpanded] = useState(null);
    const [buttonHostDisable, setButtonHostDisable] = useState(true);
    const [hostLoading, setHostLoading] = useState(false);
    const [itensLoading, setItensLoading] = useState(false);
    const [openModalMap, setOpenModalMap] = useState(false);
    const [coordenatesValid, setCoordenatesValid] = useState(false);
    const [description, setDescription] = useState("");
    //variaveis da caixa de texto/html (tipo 3)
    const [boxMode, setBoxMode] = useState("text");
    const [boxContent, setBoxContent] = useState("");
    const [backgroundColor, setBackgroundColor] = useState("");
    const [textColor, setTextColor] = useState("");
    const [fontSize, setFontSize] = useState("");
    const [colorPickerAnchor, setColorPickerAnchor] = useState(null);
    //variaveis da área/polígono (tipo 4)
    const [polygonColor, setPolygonColor] = useState("");
    const [fillColor, setFillColor] = useState("");
    const [importingKml, setImportingKml] = useState(false);

    const [importPrecision, setImportPrecision] = useState(DEFAULT_PRECISION);
    const kmlInputRef = useRef(null);

    const [valueTab, setValueTab] = useState(hasEnlace ? 0 : 1);
    const [searchText, setSearchText] = useState("");
    const styles = useStyles(theme, fullScreem, editMode);
    // "Texto" (tipo 3) e "Área" (tipo 4) compartilham o comportamento de não
    // ter host/ícone/conexões. "Área" ainda exige nome (usado p/ filtros).
    const isArea = typeElement === "Área";
    const isShape = typeElement === "Texto" || isArea;
    const polygonPoints = element?.elementConfig?.config?.polygon?.points || [];
    const precisionLevel = getPrecisionLevel(importPrecision);
    const handleChangeTab = useCallback(
      (_, newValue) => setValueTab(newValue),
      [],
    );
    const [editingConnection, setEditingConnection] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [typeElementView, setTypeElementView] = useState("automatic");
    const [nodeSize, setNodeSize] = useState(0);

    const openLocalEnlace = (index) => {
      const conn = { ...connectionsElement[index] };
      setEditingConnection(conn);

      setEditingIndex(index);
      setOpenEnlaceBar(true);
    };

    const {
      mapId,
      elements,
      connections,
      setElements = () => {},
      setConnections = () => {},
      setSnackbar = () => {},
      setElementSelected = () => {},
      configurationMap,
    } = useMapa();

    const connectionsFromMap = useMemo(
      () => [...connections?.values()],
      [connections],
    );
    const refId = useMemo(
      () => element?.id ?? element?.tempId ?? null,
      [element?.id, element?.tempId],
    );

    useImperativeHandle(ref, () => ({
      update() {
        updateElement();
      },
      create() {
        createElement();
      },
    }));

    const saveConnectionLocal = (
      updatedConnection,
      _edgeSelected,
      line,
      capacidade,
      animation,
      hostOriginId,
      flagLimiteAutomatico,
      flagCapacidadeAutomatica,
      limiteSuperiorPowerRX,
      limiteInferiorPowerRX,
      limiteSuperiorPowerTX,
      limiteInferiorPowerTX,
      sourceHandle,
      targetHandle,
      viewTypeLabel,
      interfaceDescription,
      interfaceName,
      edgeLabelSize,
    ) => {
      const newConn = {
        ...updatedConnection,
        config: {
          ...(updatedConnection.config || {}),
          type: line,
          capacidade,
          animation,
          hostOriginId,
          flagLimiteAutomatico,
          flagCapacidadeAutomatica,
          limiteSuperiorPowerRX,
          limiteInferiorPowerRX,
          limiteSuperiorPowerTX,
          limiteInferiorPowerTX,
          sourceHandle,
          targetHandle,
          viewTypeLabel,
          interfaceDescription,
          interfaceName,
          edgeLabelSize,
        },
      };

      setConnectionsElement((prev) => {
        const next = [...prev];
        next[editingIndex] = newConn;
        return next;
      });

      setEditingConnection(newConn);
      setOpenEnlaceBar(false);
      setCheckChanges(true);
    };

    useEffect(() => {
      // "Host" usa nome próprio; "Texto"/"Área" (shapes) também não devem
      // ter o nome sobrescrito pelo mapa de referência.
      if (typeElement == "Host" || isShape) return;
      setElementName(mapRefElement?.nome);
    }, [mapRefElement]);

    useEffect(() => {
      if (connectionsFromMap?.length == 0 || !element?.id) {
        setConnectionsElement([]);
        setConnectionsElementOld([]);
        return;
      }
      let con = connectionsFromMap?.filter((a) => {
        return a.referenceId == element.id;
      });

      setConnectionsElement(con);
      setConnectionsElementOld(con);
    }, [connectionsFromMap, element]);

    useEffect(() => {
      if (!element) return;
      if (!element?.elementConfig?.config?.coordenadas && tipoMapa == 0) {
        handleUpdatePositionElement(null, centerLeaflatMap);
        setCoordinatesLat(centerLeaflatMap?.lat);
        setCoordinatesLon(centerLeaflatMap.lng);
      } else {
        setCoordinatesLat(element?.elementConfig?.config?.coordenadas?.lat);
        setCoordinatesLon(element?.elementConfig?.config?.coordenadas?.long);
      }
    }, [element]);

    useEffect(() => {
      setCheckChanges(false);

      if (!element) return;

      if (!element.id) {
        clean();
      }

      setTypeElement(tiposElementos[element?.tipo]);
      setIconElement(
        iconsElement?.find((icon) => icon.id == element.img) ||
          iconsElement?.find(
            (icon) =>
              icon.nome ==
              (element.tipo === 0
                ? "_roteador"
                : element.tipo === 1
                  ? "_mapa"
                  : "_pop"),
          ),
      );

      if (element.id) {
        setElementName(element?.titulo);
        setTypeElementView(
          element?.elementConfig?.config?.viewType || "automatic",
        );
        setNodeSize(element?.elementConfig?.config?.nodeSize || 0);
        setBoxMode(element?.elementConfig?.config?.box?.mode || "text");
        setBoxContent(element?.elementConfig?.config?.box?.content || "");
        setBackgroundColor(
          element?.elementConfig?.config?.box?.backgroundColor || "",
        );
        setTextColor(element?.elementConfig?.config?.box?.textColor || "");
        setFontSize(
          element?.elementConfig?.config?.box?.fontSize != null
            ? String(element.elementConfig.config.box.fontSize)
            : "",
        );
        setPolygonColor(element?.elementConfig?.config?.polygon?.color || "");
        setFillColor(element?.elementConfig?.config?.polygon?.fillColor || "");
        if (element.mapRefId == null && element.tipo == 0) {
          setHostsConfig(element?.elementConfig?.config?.hosts);
          setItensConfig(element?.elementConfig?.config?.hosts[0]?.itens || []);
          setDescription(element?.elementConfig?.config?.descricao);
        } else {
          setHostsConfig(
            element?.mapRef?.Element?.flatMap(
              (ele) => ele.elementConfig?.config?.hosts,
            ),
          );
          setItensHost([]);
          setItensConfig([]);
        }
        setMapRefElement(maps?.find((map) => map.id == element?.mapRefId));

        //selecionarProduto
        if (produtos?.length == 1) {
          setProductElement(produtos[0]);
        } else if (produtos?.length > 1) {
          setProductElement(
            produtos.find(
              (produto) =>
                produto.id == element?.elementConfig?.config?.produtoId,
            ) || produtos[0],
          );
        } else {
          setProductElement(null);
        }

        setCoordinatesLat(element?.elementConfig?.config?.coordenadas?.lat);
        setCoordinatesLon(element?.elementConfig?.config?.coordenadas?.long);
      } else {
        if (produtos?.length >= 1) {
          setProductElement(produtos[0]);
          if (typeElement == "Host") {
            getHosts(produtos[0]?.AcessoLink[0]?.link);
          }
        } else {
          setProductElement(null);
        }
      }
    }, [element?.id, element?.tipo, element?.img]);

    //fuções
    useEffect(() => {
      if (productElement == null) {
        setHostsCliente([]);
        setHostsConfig([]);
        setItensConfig([]);
        setButtonHostDisable(true);
      }
      if (
        productElement != null &&
        Array.isArray(productElement?.AcessoLink) &&
        productElement?.AcessoLink?.length > 0 &&
        productElement?.AcessoLink[0]?.link != undefined &&
        typeElement == "Host"
      ) {
        setButtonHostDisable(true);
        getHosts(productElement?.AcessoLink[0]?.link);
      }
    }, [productElement, typeElement]);

    useEffect(() => {
      if (hostsConfig?.length == 0) {
        setItensHost([]);
        setConnectionsElement((data) => {
          data?.map((conection) => {
            conection.item = [];
          });
          return [...data];
        });
      }
      //remove os items que não tem host seleciocionado
      setItensHost((data) => {
        let filter = data?.filter((item) => {
          return hostsConfig?.some((host) => {
            return host?.hostid == item?.hostid;
          });
        });
        return [...filter];
      });
      //adiciona itens de novos host selecionados
      hostsConfig?.map(async (host) => {
        getItens(host?.hostid);
      });

      setHostsConfigOld(hostsConfig?.map((host) => ({ hostid: host?.hostid })));
    }, [hostsConfig]);

    useEffect(() => {
      if (typeElement !== "Host") return;

      const newHostId = hostsConfig?.[0]?.hostid ?? null;

      setConnectionsElement((prev) =>
        prev.map((c) => {
          const sameRef = refId ? c.referenceId === refId : true;
          if (!sameRef) return c;

          const oldHostId = c.config?.hostOriginId ?? null;
          if (oldHostId === newHostId) return c;

          return {
            ...c,
            config: { ...(c.config || {}), hostOriginId: newHostId },
          };
        }),
      );
    }, [refId, hostsConfig, typeElement]);

    useEffect(() => {
      if (!openEnlaceBar) return;
      if (editingIndex == null) return;

      const current = connectionsElement[editingIndex] ?? null;
      setEditingConnection(current);
    }, [connectionsElement, editingIndex, openEnlaceBar]);

    useEffect(() => {
      if (!element?.id || !element?.tempId) return;

      setConnectionsElement((prev) =>
        prev.map((c) =>
          c.referenceId === element.tempId
            ? { ...c, referenceId: element.id }
            : c,
        ),
      );
    }, [element?.id, element?.tempId]);

    useEffect(() => {
      if (isPointInBounds({ lat: coordinatesLat, lng: coordinatesLon }))
        setCoordenatesValid(true);
      else {
        setCoordenatesValid(false);
      }
    }, [coordinatesLat, coordinatesLon]);

    const validHost = useCallback(() => {
      return Array.isArray(hostsConfig) &&
        hostsConfig?.length > 0 &&
        hostsConfig[0]
        ? hostsConfig[0]
        : [];
    }, [hostsConfig]);

    async function getHosts(link) {
      setHostLoading(true);
      try {
        const response = await api.post("/easyMaps/zabbix/hosts", {
          link: productElement?.AcessoLink[0]?.link,
        });
        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: Não foi possível buscar os hosts",
            severity: "error",
          });
        } else {
          setButtonHostDisable(false);
          setHostsCliente(response.data);
        }
      } catch (error) {
        console.error(error);
        setSnackbar({
          children: "Error: Não foi possível se conectar com o servidor",
          severity: "error",
        });
      } finally {
        setHostLoading(false);
      }
    }

    async function getItens(hostid) {
      if (hostsConfig?.length == 0) return;
      setItensLoading(true);
      try {
        const response = await api.post("/easyMaps/zabbix/itens", {
          link: productElement?.AcessoLink[0]?.link,
          hostids: hostid,
        });
        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: Não foi possível buscar os hosts",
            severity: "error",
          });
        } else {
          const itens =
            response.data?.filter(
              (item) =>
                item.key_ != "icmpping" &&
                item.key_ != "icmppingsec" &&
                item.key_ != "icmppingloss",
            ) || [];
          setItensHost((data) => [...data, ...itens]);
        }
      } catch (error) {
        console.error(error);
        setSnackbar({
          children: "Error: Não foi possível se conectar com o servidor",
          severity: "error",
        });
      } finally {
        setItensLoading(false);
      }
    }

    async function handleApiGetElements(mapId) {
      setHostsConfig([]);
      setItensLoading(true);
      setHostLoading(true);
      try {
        //setLoadingProdutos(true);
        const response = await api.post("/easyMaps/element/findMany", {
          mapId,
        });
        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: Não foi possível buscar o mapa",
            severity: "error",
          });
        } else {
          const element = response.data.responseAlerts;

          setHostsConfig(
            element
              ?.filter((ele) => ele.tipo == 0)
              ?.flatMap((map) => map.elementConfig?.config?.hosts),
          );
        }
      } catch (error) {
        console.error(error);
        setSnackbar({
          children: "Error: Não foi possível se conectar com o servidor",
          severity: "error",
        });
      } finally {
        setHostLoading(false);
        setItensLoading(false);
      }
    }

    // Converte o valor digitado (string) em um número de fonte válido; retorna
    // null quando vazio/inválido/<=0 para que a renderização use o padrão.
    function parseFontSize(value) {
      const parsed = parseFloat(value);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    }

    async function createElement() {
      setRequestSend(true);
      if (!isValidate()) return;

      let logs = JSON.parse(localStorage.getItem("logs"));
      let data = {
        titulo:
          typeElement === "Texto" ? elementName || "textBox" : elementName,
        //descricao: description,
        tipo: tiposElementos.indexOf(typeElement),
        img: iconElement?.id ?? null,
        mapRefId: mapRefElement?.id || null,
        configuracao: {
          descricao: description,
          coordenadas:
            tipoMapa == 0
              ? {
                  lat: coordinatesLat || centerLeaflatMap?.lat,
                  long: coordinatesLon || centerLeaflatMap?.lng,
                }
              : {
                  lat: coordenadasFlow?.y
                    ? coordenadasFlow?.y + Math.floor(Math.random() * 21) - 10
                    : 0,
                  long: coordenadasFlow?.x
                    ? coordenadasFlow?.x + Math.floor(Math.random() * 21) - 10
                    : 0,
                },
          hosts:
            typeElement === "Host"
              ? [{ ...validHost(), itens: itensConfig }]
              : isShape
                ? []
                : hostsConfig,
          produtoId: productElement?.id,
          viewType: typeElementView,
          nodeSize: nodeSize,
          box: {
            mode: boxMode,
            content: boxContent,
            backgroundColor,
            textColor,
            fontSize: parseFontSize(fontSize),
          },
          polygon: {
            points: polygonPoints,
            color: polygonColor,
            fillColor,
          },
        },
        mapId: mapId,
        usuarioClienteId: logs.usuarioClienteId,
        logsLoginClienteId: logs.id,
        connections: connectionsElement
          ?.filter(
            (con) => con.destinationId !== "" && con.destinationId != null,
          )
          .map(({ referenceId, ...rest }) => rest),
      };

      try {
        const response = await api.post("/easyMaps/element", data);
        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: Não foi possível criar o elemento",
            severity: "error",
          });
        } else {
          updateDataElementSocket();
          setSnackbar({
            children: "Elemento criado com sucesso!",
            severity: "success",
          });
          closeDrawer();

          let newElement = response.data.element;
          // O endpoint de criação pode não retornar polygon.points no body;
          // injetamos os dados conhecidos para que o layer mostre imediatamente.
          if (isArea && polygonPoints.length > 0) {
            newElement = {
              ...newElement,
              elementConfig: {
                ...newElement.elementConfig,
                config: {
                  ...newElement.elementConfig?.config,
                  polygon: {
                    points: polygonPoints,
                    color: polygonColor,
                    fillColor,
                  },
                  ...(element?.elementConfig?.config?.coordenadas
                    ? {
                        coordenadas: element.elementConfig.config.coordenadas,
                      }
                    : {}),
                },
              },
            };
          }
          let newLinks = response.data.element.connections;
          setElements((prev) => {
            const next = new Map(prev);
            next.set(newElement.id, newElement);
            return next;
          });

          if (newLinks?.length) {
            setConnections((prev) => {
              const next = new Map(prev);
              newLinks.forEach((l) => l?.id != null && next.set(l.id, l));
              return next;
            });
          }
          setFocusNodeId(response.data.element?.id);
          let cood = newElement.elementConfig.config.coordenadas;
          focusZoomCoordenates(cood.lat, cood.long);
        }
      } catch (error) {
        setSnackbar({
          children: "Error: Não foi possível se conectar com o servidor",
          severity: "error",
        });
      } finally {
        setCheckChanges(false);
      }
    }

    async function updateElement() {
      setRequestSend(true);

      if (!isValidate()) return;

      const iconExists = iconsElement?.some(
        (icon) => icon.id === iconElement?.id,
      );
      const safeIconId = iconExists ? iconElement?.id : null;
      //verificar o que foi alterado nas conexões
      let arrayDelete = [];
      //verifica se houve delete
      connectionsElementOld?.map((connectionOld) => {
        if (!connectionsElement?.some((con) => con.id == connectionOld.id)) {
          arrayDelete.push(connectionOld.id);
        }
      });

      // atualização do elemento puro
      let logs = JSON.parse(localStorage.getItem("logs"));
      let data = {
        id: element.id,
        titulo:
          typeElement === "Texto" ? elementName || "textBox" : elementName,
        mapRefId: mapRefElement?.id || null,
        tipo: tiposElementos.indexOf(typeElement),
        img: safeIconId,
        configuracao: {
          descricao: description,
          coordenadas:
            tipoMapa == 0
              ? {
                  lat:
                    coordinatesLat == "" || !coordinatesLat
                      ? centerLeaflatMap?.lat
                      : coordinatesLat,
                  long:
                    coordinatesLon == "" || !coordinatesLon
                      ? centerLeaflatMap?.lng
                      : coordinatesLon,
                }
              : {
                  lat: coordinatesLat,
                  long: coordinatesLon,
                },
          hosts:
            typeElement === "Host"
              ? [{ ...validHost(), itens: itensConfig }]
              : isShape
                ? []
                : hostsConfig,
          produtoId: productElement?.id,
          viewType: typeElementView,
          nodeSize: nodeSize,
          box: {
            mode: boxMode,
            content: boxContent,
            backgroundColor,
            textColor,
            fontSize: parseFontSize(fontSize),
          },
          polygon: {
            points: polygonPoints,
            color: polygonColor,
            fillColor,
          },
        },
        connections: {
          updates: connectionsElement?.filter(
            (con) => con.destinationId != "" && con.destinationId != null,
          ),
          deletes: arrayDelete,
        },
        usuarioClienteId: logs.usuarioClienteId,
        logsLoginClienteId: logs.id,
      };
      try {
        const response = await api.put("/easyMaps/element", data);
        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: Não foi possível criar o elemento",
            severity: "error",
          });
        } else {
          updateDataElementSocket();
          setSnackbar({
            children: "Elemento atualizado com sucesso!",
            severity: "success",
          });
          setRequestSend(false);

          let updateElement = response.data.element;
          if (isArea && polygonPoints.length > 0) {
            updateElement = {
              ...updateElement,
              elementConfig: {
                ...updateElement.elementConfig,
                config: {
                  ...updateElement.elementConfig?.config,
                  polygon: {
                    points: polygonPoints,
                    color: polygonColor,
                    fillColor,
                  },
                  ...(element?.elementConfig?.config?.coordenadas
                    ? {
                        coordenadas: element.elementConfig.config.coordenadas,
                      }
                    : {}),
                },
              },
            };
          }
          let updatedLinks = response.data.updatedLinks;

          setElements((prev) => {
            const next = new Map(prev);
            next.set(updateElement.id, updateElement);
            return next;
          });
          setConnections((prev) => {
            const next = new Map(prev);

            // Remove conexões com o mesmo referenceId
            [...next.entries()]
              .filter(([, v]) => v.referenceId === element.id)
              .forEach(([k]) => next.delete(k));

            // Adiciona/atualiza os links válidos
            updatedLinks?.forEach((link) => {
              if (link?.id != null) next.set(link.id, link);
            });

            return next;
          });
        }
      } catch (error) {
        setSnackbar({
          children: "Error: Não foi possível se conectar com o servidor",
          severity: "error",
        });
      } finally {
        setCheckChanges(false);
      }
    }

    function addConexao() {
      const hostOriginId = hostsConfig?.[0]?.hostid ?? null;

      const newConn = {
        id: uuidv4(),
        referenceId: refId,
        destinationId: null,
        item: [],
        config: typeElement == "Host" ? { hostOriginId } : null,
      };

      setConnectionsElement((prev) => [...prev, newConn]);
      setEditingIndex(connectionsElement.length);
      setEditingConnection(newConn);
      setOpenEnlaceBar(true);
    }

    function removeConexao(id) {
      setConnectionsElement((data) => {
        return [...data?.filter((con) => con.id !== id)];
      });
    }

    function clean() {
      setRequestSend(false);
      setConnectionsElement([]);
      setElementName(null);
      setHostsConfig([]);
      setItensConfig([]);
      setProductElement(null);
      setMapRefElement(null);
      setExpanded(null);
      setMapRefElement(null);
      setIconElement(null);
      setCoordinatesLon(null);
      setCoordinatesLat(null);
      setTypeElementView("automatic");
      setNodeSize(0);
      setBoxMode("text");
      setBoxContent("");
      setBackgroundColor("");
      setTextColor("");
      setFontSize("");
      setColorPickerAnchor(null);
      setPolygonColor("");
      setFillColor("");
      setImportPrecision(DEFAULT_PRECISION);
    }
    function closeDrawer() {
      setElementSelected(null);
      handleReload();
      clean();
    }

    // Lê o KML/KMZ e pede confirmação antes de criar (não cria direto).
    async function handleImportKml(e) {
      const file = e.target.files?.[0];
      // Permite reimportar o mesmo arquivo logo em seguida.
      if (kmlInputRef.current) kmlInputRef.current.value = "";
      if (!file) return;

      setImportingKml(true);
      try {
        const { tolerance, applied, clamped } = resolvePrecision(
          file,
          importPrecision,
        );
        const polygons = await parsePolygonFile(file, { tolerance });

        const raw = polygons.reduce((acc, p) => acc + (p.rawCount ?? 0), 0);
        const kept = polygons.reduce((acc, p) => acc + p.points.length, 0);
        const parts = [
          `Encontrado(s) ${polygons.length} polígono(s) no arquivo.`,
          raw > kept
            ? `Precisão ${applied.label}: ${raw} vértices reduzidos para ${kept}.`
            : `Precisão ${applied.label}: ${kept} vértices mantidos.`,
        ];
        if (clamped) {
          parts.push(
            `O arquivo é grande demais para a precisão escolhida — ela foi limitada a "${applied.label}" (~${applied.meters} m) para preservar o desempenho do mapa.`,
          );
        }
        parts.push("Deseja importá-los como áreas?");

        setOpenAlertModal({
          open: true,
          severity: clamped ? "warning" : "info",
          text: parts.join(" "),
          buttonText: "Importar",
          buttonCancelText: "Cancelar",
          callback: () => doImportPolygons(polygons),
        });
      } catch (error) {
        setSnackbar({
          children:
            error?.message ||
            error?.response?.data?.error ||
            "Error: Não foi possível ler o arquivo",
          severity: "error",
        });
      } finally {
        setImportingKml(false);
      }
    }

    // Refaz o findMany e repopula os Maps do contexto (mesma lógica do load
    // inicial do mapa). Self-contained: garante a exibição imediata das áreas.
    async function reloadMapElements() {
      const refetch = await api.post("/easyMaps/element/findMany", { mapId });
      if (refetch?.data && refetch.data.status !== "Error") {
        setElements(
          new Map((refetch.data.responseAlerts || []).map((el) => [el.id, el])),
        );
        setConnections(
          new Map((refetch.data.connections || []).map((c) => [c.id, c])),
        );
      }
    }

    // Cria um elemento "Área" por polígono; cada um recebe uma cor diferente.
    async function doImportPolygons(polygons) {
      setImportingKml(true);
      try {
        const logs = JSON.parse(localStorage.getItem("logs"));
        const elementsData = polygons.map((poly, i) => ({
          titulo: poly.name || `Área ${i + 1}`,
          tipo: 4,
          img: null,
          mapRefId: null,
          mapId,
          configuracao: {
            descricao: "",
            coordenadas: polygonCentroid(poly.points),
            hosts: [],
            viewType: "automatic",
            polygon: {
              points: poly.points,
              color: IMPORT_POLYGON_COLORS[i % IMPORT_POLYGON_COLORS.length],
            },
          },
        }));

        const response = await api.post("/easyMaps/element/createMany", {
          elementsData,
          usuarioClienteId: logs.usuarioClienteId,
          logsLoginClienteId: logs.id,
        });

        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: Não foi possível importar as áreas",
            severity: "error",
          });
        } else {
          setSnackbar({
            children: `${elementsData.length} área(s) importada(s) com sucesso!`,
            severity: "success",
          });
          // Recarrega os elementos diretamente no contexto do mapa para que as
          // áreas apareçam sem precisar de F5 (não depende de props do pai).
          await reloadMapElements();
          closeDrawer();
        }
      } catch (error) {
        setSnackbar({
          children:
            error?.message ||
            error?.response?.data?.error ||
            "Error: Não foi possível importar as áreas",
          severity: "error",
        });
      } finally {
        setImportingKml(false);
      }
    }

    const isOptionEqualToValue = (option, value) => {
      return option?.hostid === value?.hostid;
    };
    const isOptionEqualToValueNome = (option, value) => {
      return option?.nome === value?.nome;
    };

    const isValidate = () => {
      if (typeElement === "Texto") {
        return (
          typeElement != null &&
          productElement != null &&
          (tipoMapa == 0 ? coordenatesValid : true)
        );
      }
      if (isArea) {
        return (
          elementName != "" && elementName != null && polygonPoints?.length >= 3
        );
      }
      if (typeElement === "Mapa" || typeElement === "POP") {
        return (
          mapRefElement != null &&
          elementName != "" &&
          elementName != null &&
          typeElement != null &&
          productElement != null &&
          iconElement != null &&
          (tipoMapa == 0 ? coordenatesValid : true)
        );
      } else {
        return (
          elementName != "" &&
          elementName != null &&
          hostsConfig?.length != 0 &&
          hostsConfig[0] != null &&
          typeElement != null &&
          productElement != null &&
          iconElement != null &&
          (tipoMapa == 0 ? coordenatesValid : true)
        );
      }
    };
    const mapsFilter = (maps, tipo) => {
      return tipo == "POP"
        ? maps?.filter(({ tipo, id }) => tipo == 2 && id != mapId)
        : maps?.filter(({ tipo, id }) => tipo != 2 && id != mapId);
    };
    const selectMapRef = (map) => {
      const newValue = { nome: map?.titulo, tipo: map?.tipo, id: map?.id };
      setMapRefElement(newValue);
      setElementName(newValue?.nome);
      if (newValue) handleApiGetElements(newValue.id);
      else setHostsConfig([]);
    };
    useEffect(() => {
      if (element === null) {
        clean();
      }
    }, [element]);

    const handleOnDeleteIcon = (id) => {
      setOpenAlertModal({
        open: true,
        severity: "error",
        text: "Essa ação apagará o icon do banco de forma irreversível.\n Deseja continuar?",
        callback: async () => {
          try {
            const response = await api.put("easyMaps/img/delete", { id });
            if (response.data.status === "Error") {
              setSnackbar({
                children: "Error: não foi possível deletar o icon",
                severity: "error",
              });
            } else {
              setIconsElement((icons) => {
                let newicons = icons.filter((a) => a.id != id);
                return [...newicons];
              });
              setSnackbar({
                children: "Icone excluido com sucesso",
                severity: "success",
              });
            }
          } catch (error) {
            setSnackbar({
              children: "Error: Não foi possivel se conectar com o servidor",
              severity: "error",
            });
          }
        },
      });
    };
    function verificarIpPosicao(string) {
      const padraoIpv4 = /\b(?:\d{1,3}\.){3}\d{1,3}\b/g;
      const padraoIpv6 = /\b(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}\b/g;
      let match;

      // Verificar IPv4 primeiro
      if ((match = padraoIpv4.exec(string)) !== null) {
        return match.index;
      }
      // Verificar IPv6 se não encontrou IPv4
      if ((match = padraoIpv6.exec(string)) !== null) {
        return match.index;
      }
      return -1;
    }

    return (
      <>
        <Drawer
          key={"creationBar"}
          variant="persistent"
          anchor={"right"}
          open={!!element}
          //onClose={() => closeDrawer()}
          sx={styles.drawer}
        >
          <Stack sx={[styles.header, styles.card]}>
            <IconTransform img={iconElement?.img} size="35px" />
            <Divider orientation="vertical" />
            <Stack>
              <Tooltip title={elementName}>
                <Typography sx={styles.textPaperTitle}>
                  {elementName ? elementName : "Novo elemento"}
                </Typography>
              </Tooltip>
              <Typography
                sx={{
                  fontSize: "12px",
                  mt: "-5px",
                  color: theme.palette.color.textDisable,
                }}
              >
                {typeElement}
              </Typography>
            </Stack>
          </Stack>
          <Stack sx={styles.container}>
            {/* <Stack direction="row" gap={2} alignItems="center">
              <Produto
                style={{
                  fill: theme.palette.primary.main,
                  height: "24px",
                  width: "24px",
                }}
              />
              <Typography sx={styles.text}>
                Selecione o produto de origem
              </Typography>
            </Stack>
            <Autocomplete
              getOptionLabel={(option) => option?.nome}
              disabled={produtos?.length == 0}
              value={productElement || null}
              onChange={(event, newValue) => {
                setCheckChanges(true);
                setProductElement(newValue);
              }}
              size="small"
              options={produtos || []}
              ListboxComponent={VirtualizedListbox}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ padding: "0px" }} key={option.itemid}>
                  <Tooltip title={option.nome} placement="left-start">
                    <Stack sx={styles.stackOption}>
                      <Checkbox checked={selected} />
                      <span style={styles.textoLimitado}>{option.nome}</span>
                    </Stack>{" "}
                  </Tooltip>
                </li>
              )}
              renderInput={(params) => {
                return (
                  <>
                    <TextField
                      {...params}
                      error={requestSend && productElement == null}
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <ZabbixIcon
                                style={{
                                  fill: theme.palette.color.bgIcon,
                                  height: "20px",
                                  width: "20px",
                                }}
                              />
                            </InputAdornment>
                          ),
                        },
                      }}
                      helperText={
                        requestSend &&
                        productElement == null &&
                        "O produto precisa ser indicado!"
                      }
                      color="primary"
                    />
                  </>
                );
              }}
            /> */}
            {isArea && (
              <>
                <Button
                  startIcon={<BorderColorOutlined />}
                  variant="outlined"
                  onClick={() => setOpenMassEditPolygon(true)}
                  sx={{
                    textTransform: "none",
                  }}
                >
                  Editar áreas em massa
                </Button>
                <Divider />
              </>
            )}
            <Stack direction="row" gap={2} alignItems={"center"}>
              <SettingsOutlinedIcon color="primary" />
              <Typography sx={styles.text}>Selecione o tipo</Typography>
            </Stack>

            <Autocomplete
              key={"autocompleteTipo"}
              value={typeElement || null}
              onChange={(event, newValue) => {
                setCheckChanges(true);
                setMapRefElement(null);
                // setHostsConfig([]);
                setTypeElement(newValue);
              }}
              ListboxComponent={VirtualizedListbox}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ padding: "0px" }} key={option.itemid}>
                  <Tooltip title={option} placement="left-start">
                    <Stack sx={styles.stackOption}>
                      <Checkbox checked={selected} />
                      <span style={styles.textoLimitado}>{option}</span>
                    </Stack>{" "}
                  </Tooltip>
                </li>
              )}
              id="combo-dsadbox-demo"
              size="small"
              color="primary"
              options={tiposElementos}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Tipo de elemento"
                  error={requestSend && typeElement == null}
                  helperText={
                    requestSend &&
                    typeElement == null &&
                    "O tipo não pode ser nulo!"
                  }
                  color="primary"
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      startAdornment: (
                        <Box sx={{ mr: "-5px" }}>
                          <InputAdornment position="start">
                            {typeElement == null && (
                              <SettingsOutlinedIcon
                                sx={{
                                  color: theme.palette.color.bgIcon,
                                  fontSize: "20px",
                                }}
                              />
                            )}
                            {typeElement == "Host" && (
                              <IconTransform
                                img={
                                  iconsElement.find(
                                    (icon) => icon.nome == "_roteador",
                                  )?.img
                                }
                                size="20px"
                                color={theme.palette.color.bgIcon}
                              />
                            )}
                            {typeElement == "Mapa" && (
                              <IconTransform
                                img={
                                  iconsElement.find(
                                    (icon) => icon.nome == "_mapa",
                                  )?.img
                                }
                                size="20px"
                                color={theme.palette.color.bgIcon}
                              />
                            )}
                            {typeElement == "POP" && (
                              <IconTransform
                                img={
                                  iconsElement.find(
                                    (icon) => icon.nome == "_pop",
                                  )?.img
                                }
                                size="20px"
                                color={theme.palette.color.bgIcon}
                              />
                            )}
                            {typeElement == "Texto" && (
                              <TextFields
                                sx={{
                                  color: theme.palette.color.bgIcon,
                                  fontSize: "20px",
                                }}
                              />
                            )}
                            {typeElement == "Área" && (
                              <HexagonOutlined
                                sx={{
                                  color: theme.palette.color.bgIcon,
                                  fontSize: "20px",
                                }}
                              />
                            )}
                          </InputAdornment>
                        </Box>
                      ),
                    },
                  }}
                />
              )}
            />
            {typeElement == "Host" ? (
              <>
                <Stack direction="row" gap={2} alignItems="center">
                  <>
                    <StorageOutlinedIcon color="primary" />
                    <Typography sx={styles.text}>Selecione o host</Typography>
                  </>
                </Stack>

                <Autocomplete
                  disablePortal
                  disabled={buttonHostDisable}
                  getOptionLabel={(option) => option?.host || ""}
                  isOptionEqualToValue={isOptionEqualToValue}
                  id="combo-box-demo"
                  size="small"
                  color="primary"
                  options={hostsCliente || []}
                  value={
                    Array.isArray(hostsConfig) && hostsConfig.length > 0
                      ? hostsConfig[0]
                      : null
                  }
                  ListboxComponent={VirtualizedListbox}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{ padding: "0px" }}
                      key={option.itemid}
                    >
                      <Tooltip title={option.host} placement="left-start">
                        <Stack sx={styles.stackOption}>
                          <Checkbox checked={selected} />
                          <span style={styles.textoLimitado}>
                            {option.host}
                          </span>
                        </Stack>{" "}
                      </Tooltip>
                    </li>
                  )}
                  onChange={(event, newValue) => {
                    setCheckChanges(true);
                    //setItensLoading(true);
                    if (newValue == null) setHostsConfig([]);
                    else
                      setHostsConfig([
                        { ...newValue, hostname: newValue.host },
                      ]);

                    if (newValue?.hostid !== validHost()?.hostid)
                      setItensConfig([]);

                    //lógica para inseriro o nome do elemnto sem o ip
                    if (verificarIpPosicao(newValue?.host) != -1) {
                      setElementName(
                        newValue.host?.substring(
                          0,
                          verificarIpPosicao(newValue?.host) - 3,
                        ),
                      );
                    } else {
                      setElementName(newValue?.host);
                    }
                  }}
                  renderInput={(params) => (
                    <>
                      <TextField
                        {...params}
                        placeholder="Host"
                        error={
                          requestSend &&
                          (hostsConfig?.length == 0 || hostsConfig[0] == null)
                        }
                        helperText={
                          (requestSend &&
                            (hostsConfig?.length == 0 ||
                              hostsConfig[0] == null) &&
                            "O host não pode ser nulo!") ||
                          (buttonHostDisable &&
                            "Esse produto não tem hosts disponíveis")
                        }
                        color="primary"
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            startAdornment: (
                              <Box sx={{ mr: "-5px" }}>
                                <InputAdornment position="start">
                                  <IconTransform
                                    img={
                                      iconsElement.find(
                                        (icon) => icon.nome == "_roteador",
                                      )?.img
                                    }
                                    size="20px"
                                    color={theme.palette.color.bgIcon}
                                  />
                                </InputAdornment>
                              </Box>
                            ),
                          },
                        }}
                      />
                      <Fade in={hostLoading}>
                        <LinearProgress sx={{ height: "2px" }} />
                      </Fade>
                    </>
                  )}
                />
                <Stack direction="row" gap={2} alignItems="center">
                  <>
                    {/* <StorageOutlinedIcon color="primary" /> */}
                    <ItemIcon
                      style={{
                        fill: theme.palette.primary.main,
                        height: "24px",
                        width: "24px",
                      }}
                    />
                    <Typography sx={styles.text}>
                      Selecione os itens do host
                    </Typography>
                  </>
                </Stack>

                <Autocomplete
                  multiple
                  key="itensAutocomplete"
                  disableCloseOnSelect
                  //sx={{ width: "245px" }}
                  disabled={typeElement != "Host" && validHost() == null}
                  //disablePortal
                  id="itensHost"
                  size="small"
                  color="primary"
                  options={
                    typeElement == "Host"
                      ? itensHost
                      : itensHost?.filter(
                          (item) => item?.hostid === validHost()?.hostid,
                        )
                  }
                  value={itensConfig}
                  onChange={(event, newValue) => {
                    setCheckChanges(true);
                    setItensConfig(newValue);
                  }}
                  inputValue={searchText}
                  onInputChange={(event, newInputValue, reason) => {
                    switch (reason) {
                      case "input":
                        setSearchText(newInputValue);
                        break;
                      case "reset":
                        break;
                      case "blur":
                      case "clear":
                        setSearchText("");
                        break;
                      default:
                        break;
                    }
                  }}
                  ListboxComponent={VirtualizedListbox}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{ padding: "0px" }}
                      key={option.itemid}
                    >
                      <Tooltip title={option.name} placement="left-start">
                        <Stack sx={styles.stackOption}>
                          <Checkbox checked={selected} />
                          <span style={styles.textoLimitado}>
                            {option.name}
                          </span>
                        </Stack>{" "}
                      </Tooltip>
                    </li>
                  )}
                  // renderTags={(value, getTagProps) => {
                  //   return value?.map((option, index) => (
                  //     <Tooltip
                  //       title={option.name}
                  //       key={option.itemid + "toolItens"}
                  //     >
                  //       <Chip label={option.name} {...getTagProps({ index })} />
                  //     </Tooltip>
                  //   ));
                  // }}
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option, value) =>
                    option.itemid === value.itemid
                  }
                  renderInput={(params) => {
                    return (
                      <>
                        {" "}
                        <TextField
                          {...params}
                          key="itensAutoText"
                          color="primary"
                          placeholder={itensConfig.length == 0 ? "Itens" : null}
                          helperText={
                            typeElement == "Host" && !itensLoading
                              ? itensHost?.length == 0 &&
                                "Esse elemento não contém itens"
                              : itensHost?.filter(
                                  (item) => item.hostid === validHost()?.hostid,
                                )?.length == 0 &&
                                validHost() != null &&
                                !itensLoading &&
                                "O host selecionado não contém itens"
                          }
                          slotProps={{
                            input: {
                              ...params.InputProps,
                              startAdornment: (
                                <Stack
                                  direction={"row"}
                                  justifyContent={"center"}
                                  alignItems={"center"}
                                >
                                  <InputAdornment position="start">
                                    <ViewInArOutlined
                                      sx={{
                                        color: theme.palette.color.bgIcon,
                                        fontSize: "20px",
                                      }}
                                    />
                                  </InputAdornment>
                                  <Stack
                                    sx={{
                                      maxWidth: "200px",
                                    }}
                                  >
                                    {params.InputProps.startAdornment}
                                  </Stack>
                                </Stack>
                              ),
                            },
                          }}
                        />{" "}
                        <Fade in={itensLoading}>
                          <LinearProgress sx={{ height: "2px" }} />
                        </Fade>
                      </>
                    );
                  }}
                />
              </>
            ) : typeElement == "Texto" ? (
              <>
                <Stack direction="row" gap={2} alignItems="center">
                  <Notes color="primary" />
                  <Typography sx={styles.text}>Conteúdo da caixa</Typography>
                </Stack>
                <Box sx={[styles.card, { p: 0.5, height: "50px" }]}>
                  <Tabs
                    variant="fullWidth"
                    value={boxMode}
                    onChange={(_, v) => {
                      setCheckChanges(true);
                      setBoxMode(v);
                    }}
                    textColor="primary"
                    indicatorColor="primary"
                    sx={styles.tabs}
                  >
                    <Tab value="text" label="Texto" sx={styles.text} />
                    <Tab value="html" label="HTML" sx={styles.text} />
                  </Tabs>
                </Box>
                {boxMode === "html" ? (
                  <Box
                    sx={{
                      borderRadius: "4px",
                      overflow: "hidden",
                      height: "150px",
                      flexShrink: 0,
                    }}
                  >
                    <Editor
                      height="150px"
                      language="html"
                      value={boxContent}
                      theme={
                        theme.palette.mode === "dark" ? "vs-dark" : "light"
                      }
                      onChange={(val) => {
                        setCheckChanges(true);
                        setBoxContent(val ?? "");
                      }}
                      options={{
                        minimap: { enabled: false },
                        fontSize: 13,
                        wordWrap: "on",
                        scrollBeyondLastLine: false,
                        formatOnType: true,
                        formatOnPaste: true,
                        automaticLayout: true,
                        lineNumbers: "off",
                        folding: false,
                        padding: { top: 8, bottom: 8 },
                        // Garante que a barra de rolagem interna do editor
                        // apareça e funcione, sem o scroll ser "roubado" pela
                        // sidebar — assim dá pra voltar ao topo do conteúdo.
                        scrollbar: {
                          vertical: "auto",
                          horizontal: "auto",
                          alwaysConsumeMouseWheel: false,
                          verticalScrollbarSize: 10,
                          horizontalScrollbarSize: 10,
                        },
                      }}
                    />
                  </Box>
                ) : (
                  <TextField
                    autoComplete="off"
                    value={boxContent}
                    onChange={(e) => {
                      setCheckChanges(true);
                      setBoxContent(e.target.value);
                    }}
                    color="primary"
                    placeholder="Digite o texto da caixa"
                    variant="outlined"
                    size="small"
                    multiline
                    fullWidth
                    rows={6}
                  />
                )}
                {boxMode === "text" && (
                  <>
                    <Stack direction="row" gap={2} alignItems="center">
                      <AutoAwesome color="primary" />
                      <Typography sx={styles.text}>Customização</Typography>
                    </Stack>
                    <Stack sx={[styles.card, { p: 1.5 }]} gap={1.5}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography sx={{ fontSize: "14px" }}>
                          Tamanho da fonte
                        </Typography>
                        <TextField
                          autoComplete="off"
                          value={fontSize}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Permite apenas números positivos (inteiro ou
                            // decimal): sem sinal, letras ou símbolos.
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              setCheckChanges(true);
                              setFontSize(value);
                            }
                          }}
                          size="small"
                          placeholder="13"
                          sx={{ width: 96 }}
                          slotProps={{
                            input: {
                              endAdornment: (
                                <InputAdornment position="end">
                                  px
                                </InputAdornment>
                              ),
                            },
                            htmlInput: {
                              inputMode: "decimal",
                            },
                          }}
                        />
                      </Stack>
                      <Divider />
                      {[
                        {
                          key: "background",
                          label: "Cor de fundo",
                          color: backgroundColor,
                          clear: () => {
                            setBackgroundColor("");
                            setCheckChanges(true);
                          },
                        },
                        {
                          key: "text",
                          label: "Cor do texto",
                          color: textColor,
                          clear: () => {
                            setTextColor("");
                            setCheckChanges(true);
                          },
                        },
                      ].map(({ key, label, color, clear }, i) => (
                        <Stack key={key}>
                          {i > 0 && <Divider sx={{ mb: 1.5 }} />}
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Typography
                              sx={{
                                fontSize: "14px",
                              }}
                            >
                              {label}
                            </Typography>
                            <Stack direction="row" alignItems="center" gap={1}>
                              {color && (
                                <Typography
                                  onClick={clear}
                                  sx={{
                                    fontSize: "11px",
                                    cursor: "pointer",
                                    color: theme.palette.primary.main,
                                    userSelect: "none",
                                  }}
                                >
                                  Limpar
                                </Typography>
                              )}
                              <Tooltip title={color || "Sem cor definida"}>
                                <Box
                                  onClick={(e) =>
                                    setColorPickerAnchor(
                                      colorPickerAnchor?.type === key
                                        ? null
                                        : { type: key, el: e.currentTarget },
                                    )
                                  }
                                  sx={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "8px",
                                    border: `2px solid ${
                                      colorPickerAnchor?.type === key
                                        ? theme.palette.primary.main
                                        : alpha(theme.palette.text.primary, 0.2)
                                    }`,
                                    backgroundColor:
                                      color ||
                                      alpha(theme.palette.text.primary, 0.06),
                                    cursor: "pointer",
                                    transition: "border-color 0.2s",
                                    flexShrink: 0,
                                  }}
                                />
                              </Tooltip>
                            </Stack>
                          </Stack>
                        </Stack>
                      ))}
                      <Divider />
                      <Box
                        sx={{
                          borderRadius: "8px",
                          p: 1.5,
                          backgroundColor:
                            backgroundColor || theme.palette.background.default,
                          border: `1px solid ${alpha(theme.palette.text.primary, 0.1)}`,
                          minHeight: 48,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: `${parseFontSize(fontSize) || 13}px`,
                            color: textColor || theme.palette.text.primary,
                            textAlign: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          {boxContent || "Pré-visualização"}
                        </Typography>
                      </Box>
                    </Stack>
                  </>
                )}
                {boxMode === "html" && (
                  <Stack sx={[styles.card, { p: 1 }]} gap={0.5}>
                    <Typography sx={styles.text}>Pré-visualização</Typography>
                    <Box
                      sx={{
                        color: theme.palette.text.primary,
                        overflowWrap: "anywhere",
                        // Limita a altura para que o HTML renderizado não
                        // empurre/esconda o editor; rola internamente.
                        maxHeight: "200px",
                        overflow: "auto",
                        // Impede que conteúdo largo (imagens/tabelas) estoure
                        // a largura da caixa de pré-visualização.
                        "& *": { maxWidth: "100%" },
                        "& img": { height: "auto" },
                      }}
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(boxContent),
                      }}
                    />
                  </Stack>
                )}
              </>
            ) : isArea ? (
              <>
                <Stack direction="row" gap={2} alignItems="center">
                  <TextFieldsIcon color="primary" />
                  <Typography sx={styles.text}>
                    Informe o nome da área
                  </Typography>
                </Stack>
                <TextField
                  autoComplete="off"
                  value={elementName || ""}
                  onChange={(value) => {
                    setCheckChanges(true);
                    setElementName(value.target.value);
                  }}
                  color="primary"
                  placeholder="Nome da área"
                  variant="outlined"
                  size="small"
                  error={elementName == "" || elementName == null}
                  helperText={
                    (elementName == "" || elementName == null) &&
                    "O nome é obrigatório!"
                  }
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <AbcOutlined
                            sx={{
                              ml: "-5px",
                              color: theme.palette.color.bgIcon,
                              fontSize: "24px",
                            }}
                          />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                <Stack direction="row" gap={2} alignItems="center">
                  <AutoAwesome color="primary" />
                  <Typography sx={styles.text}>Cor da área</Typography>
                </Stack>
                <Stack
                  sx={[styles.card, { p: 1.5 }]}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography sx={{ fontSize: "14px" }}>Borda</Typography>
                  <Stack direction="row" alignItems="center" gap={1}>
                    {polygonColor && (
                      <Typography
                        onClick={() => {
                          setPolygonColor("");
                          setCheckChanges(true);
                        }}
                        sx={{
                          fontSize: "11px",
                          cursor: "pointer",
                          color: theme.palette.primary.main,
                          userSelect: "none",
                        }}
                      >
                        Limpar
                      </Typography>
                    )}
                    <Tooltip
                      title={polygonColor || theme.palette.secondary.main}
                    >
                      <Box
                        onClick={(e) =>
                          setColorPickerAnchor(
                            colorPickerAnchor?.type === "polygonBorder"
                              ? null
                              : { type: "polygonBorder", el: e.currentTarget },
                          )
                        }
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: "8px",
                          border: `2px solid ${
                            colorPickerAnchor?.type === "polygonBorder"
                              ? theme.palette.primary.main
                              : alpha(theme.palette.text.primary, 0.2)
                          }`,
                          backgroundColor:
                            polygonColor || theme.palette.secondary.main,
                          cursor: "pointer",
                          transition: "border-color 0.2s",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                  </Stack>
                </Stack>
                <Stack
                  sx={[styles.card, { p: 1.5 }]}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Preenchimento
                  </Typography>
                  <Stack direction="row" alignItems="center" gap={1}>
                    {fillColor && (
                      <Typography
                        onClick={() => {
                          setFillColor("");
                          setCheckChanges(true);
                        }}
                        sx={{
                          fontSize: "11px",
                          cursor: "pointer",
                          color: theme.palette.primary.main,
                          userSelect: "none",
                        }}
                      >
                        Limpar
                      </Typography>
                    )}
                    <Tooltip
                      title={
                        fillColor ||
                        polygonColor ||
                        theme.palette.secondary.main
                      }
                    >
                      <Box
                        onClick={(e) =>
                          setColorPickerAnchor(
                            colorPickerAnchor?.type === "polygonFill"
                              ? null
                              : { type: "polygonFill", el: e.currentTarget },
                          )
                        }
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: "8px",
                          border: `2px solid ${
                            colorPickerAnchor?.type === "polygonFill"
                              ? theme.palette.primary.main
                              : alpha(theme.palette.text.primary, 0.2)
                          }`,
                          backgroundColor:
                            fillColor ||
                            polygonColor ||
                            theme.palette.secondary.main,
                          cursor: "pointer",
                          transition: "border-color 0.2s",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                  </Stack>
                </Stack>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color:
                      requestSend && polygonPoints?.length < 3
                        ? theme.palette.primary.main
                        : theme.palette.color.textDisable,
                  }}
                >
                  {`Clique no mapa para desenhar a área (mínimo de 3 pontos).`}
                </Typography>
                <Divider>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: theme.palette.color.textDisable,
                    }}
                  >
                    ou
                  </Typography>
                </Divider>
                <Stack gap={0.5} width="100%">
                  <Stack direction="row" gap={2} alignItems="center">
                    <FormatShapesOutlined color="primary" />
                    <Typography sx={styles.text}>
                      {" "}
                      Precisão do contorno
                    </Typography>
                  </Stack>
                  <Box sx={{ width: "100%", px: 2 }}>
                    <Slider
                      size="small"
                      min={PRECISION_MARKS[0].value}
                      max={PRECISION_MARKS[PRECISION_MARKS.length - 1].value}
                      step={1}
                      marks={PRECISION_MARKS}
                      value={importPrecision}
                      onChange={(_, value) => setImportPrecision(value)}
                      disabled={importingKml}
                      sx={{
                        "& .MuiSlider-markLabel": {
                          fontSize: "10px",
                          color: theme.palette.color.textDisabled,
                        },
                        "& .MuiSlider-markLabelActive": {
                          fontWeight: 600,
                          color: theme.palette.color.text,
                        },
                      }}
                    />
                  </Box>
                  <Alert severity="info">
                    {`Níveis mais baixos de precisão simplificam o contorno e deixam o mapa mais leve. Esta ação não pode ser desfeita após a importação.`}
                  </Alert>
                </Stack>
                <input
                  ref={kmlInputRef}
                  type="file"
                  accept=".kml,.kmz,.geojson,.json"
                  style={{ display: "none" }}
                  onChange={handleImportKml}
                />
                <Button
                  startIcon={<UploadFileOutlined />}
                  variant="outlined"
                  disabled={importingKml}
                  onClick={() => kmlInputRef.current?.click()}
                  sx={{ textTransform: "none" }}
                >
                  {importingKml
                    ? "Importando..."
                    : "Importar polígonos de KML/KMZ/GeoJSON"}
                </Button>
                <Typography
                  sx={{
                    fontSize: "11px",
                    color: theme.palette.color.textDisable,
                  }}
                >
                  Cada polígono do arquivo será salvo como uma área separada.
                </Typography>
                <Fade in={importingKml}>
                  <LinearProgress sx={{ height: "2px" }} />
                </Fade>
              </>
            ) : (
              <>
                <Stack direction={"column"} gap={1} alignItems={"start"}>
                  <Stack
                    direction="row"
                    gap={2}
                    alignItems="center"
                    width="100%"
                    mb={"5px"}
                  >
                    <MapOutlinedIcon color="primary" />
                    <Typography sx={styles.text}>
                      Selecione o mapa de referência
                    </Typography>
                  </Stack>

                  <Autocomplete
                    disablePortal
                    sx={{ width: "100%" }}
                    value={mapRefElement || null}
                    getOptionLabel={(option) => option?.nome || ""}
                    isOptionEqualToValue={isOptionEqualToValueNome}
                    onChange={(event, newValue) => {
                      setCheckChanges(true);
                      setMapRefElement(newValue);
                      setElementName(newValue?.nome);
                      if (newValue) handleApiGetElements(newValue.id);
                      else setHostsConfig([]);
                    }}
                    id="combo-box-demo"
                    size="small"
                    color="primary"
                    options={
                      Array.isArray(maps) ? mapsFilter(maps, typeElement) : []
                    }
                    ListboxComponent={VirtualizedListbox}
                    renderOption={(props, option, { selected }) => (
                      <li
                        {...props}
                        style={{ padding: "0px" }}
                        key={option.itemid}
                      >
                        <Tooltip title={option.nome} placement="left-start">
                          <Stack sx={styles.stackOption}>
                            <Checkbox checked={selected} />
                            <span style={styles.textoLimitado}>
                              {option.nome}
                            </span>
                          </Stack>{" "}
                        </Tooltip>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={requestSend && mapRefElement == null}
                        helperText={
                          requestSend &&
                          mapRefElement == null &&
                          "A referência do mapa não pode ser nula!"
                        }
                        color="primary"
                        placeholder="Mapa de referência"
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            startAdornment: (
                              <Box sx={{ mr: "-5px" }}>
                                <InputAdornment position="start">
                                  <IconTransform
                                    img={
                                      iconsElement.find(
                                        (icon) => icon.nome == "_mapa",
                                      )?.img
                                    }
                                    size="20px"
                                    color={theme.palette.color.bgIcon}
                                  />
                                </InputAdornment>
                              </Box>
                            ),
                          },
                        }}
                      />
                    )}
                  />
                  <Button
                    startIcon={<AddOutlinedIcon />}
                    variant="text"
                    onClick={() => setOpenModalMap(true)}
                    sx={styles.buttonAdd}
                  >
                    Criar novo mapa
                  </Button>
                </Stack>
              </>
            )}
            {!isShape && (
              <Stack direction={"column"} gap={1} alignItems={"start"}>
                <Stack
                  direction="row"
                  gap={1}
                  alignItems="center"
                  width="100%"
                  mb={"5px"}
                >
                  <NotListedLocationOutlinedIcon color="primary" />
                  <Typography sx={styles.text}>Ícone do elemento</Typography>
                </Stack>

                <PainelIcons
                  iconsElement={iconsElement}
                  iconElement={iconElement}
                  setIconElement={setIconElement}
                  setIconsElement={setIconsElement}
                  api={api}
                  setSnackbar={setSnackbar}
                  handleOnDelete={(id) => handleOnDeleteIcon(id)}
                  setCheckChanges={setCheckChanges}
                />
              </Stack>
            )}
            {typeElement == "Host" && (
              <>
                <Stack direction="row" gap={2} alignItems="center">
                  <TextFieldsIcon color="primary" />
                  <Typography sx={styles.text}>
                    Informe o nome do elemento
                  </Typography>
                </Stack>
                <TextField
                  autoComplete="off"
                  value={elementName || ""}
                  onChange={(value) => {
                    setCheckChanges(true);
                    setElementName(value.target.value);
                  }}
                  color="primary"
                  id="hostName"
                  placeholder="Nome do Elemento"
                  variant="outlined"
                  size="small"
                  error={
                    requestSend && (elementName == "" || elementName == null)
                  }
                  helperText={
                    requestSend &&
                    (elementName == "" || elementName == null) &&
                    "O nome não pode ser nulo!"
                  }
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <AbcOutlined
                            sx={{
                              ml: "-5px",
                              color: theme.palette.color.bgIcon,
                              fontSize: "24px",
                            }}
                          />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </>
            )}
            {tipoMapa == 0 && !isArea && (
              <>
                <Stack direction="row" gap={2} alignItems="center">
                  <EditLocationAltOutlinedIcon color="primary" />
                  <Typography sx={styles.text}>
                    Informe as coordenadas
                  </Typography>
                </Stack>
                <Stack direction="row" gap={1}>
                  <TextField
                    error={!coordenatesValid}
                    autoComplete="off"
                    value={coordinatesLat || ""}
                    onChange={(value) => {
                      setCheckChanges(true);
                      setCoordinatesLat(value.target.value);
                    }}
                    color="primary"
                    placeholder="Latitude"
                    variant="outlined"
                    size="small"
                    type="number"
                    sx={styles.removeIncDec}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              LAT
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />

                  <TextField
                    error={!coordenatesValid}
                    autoComplete="off"
                    value={coordinatesLon || ""}
                    onChange={(value) => {
                      setCheckChanges(true);
                      setCoordinatesLon(value.target.value);
                    }}
                    sx={styles.removeIncDec}
                    color="primary"
                    id="hostName"
                    placeholder="Longitude"
                    variant="outlined"
                    size="small"
                    type="number"
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              LNG
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Stack>{" "}
                {!coordenatesValid && (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      textAlign: "center",
                      mt: "-5px",
                      color: theme.palette.primary.main,
                    }}
                  >
                    {coordinatesLat == "" || coordinatesLon == ""
                      ? "Latitude/Longitude inválida"
                      : "O ponto precisa estar contido na área do mapa"}
                  </Typography>
                )}
              </>
            )}
            {tipoMapa == 1 && (
              <>
                <Stack direction="row" gap={2} alignItems="center"></Stack>
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <ViewComfy color="primary" fontSize="medium" />
                  <Typography sx={styles.text}>
                    Tipo de visualização do elemento
                  </Typography>
                  <BaseInfoPopover
                    title="Visualização do elemento"
                    typeInfo="nodeLabel"
                  />
                </Stack>
                <Autocomplete
                  key={"autocompleteTipoView"}
                  value={typeElementView || "automatic"}
                  onChange={(event, newValue) => {
                    setTypeElementView(newValue || "automatic");
                    changeElement(element.id, {
                      viewType: newValue,
                    });
                    setCheckChanges(true);
                  }}
                  ListboxComponent={VirtualizedListbox}
                  getOptionLabel={(option) => {
                    if (option === "detailed") return "Detalhado";
                    if (option === "compact") return "Compacto";
                    if (option === "simple") return "Simples";
                    if (option === "automatic") return "Automático";
                    return option || "";
                  }}
                  renderOption={(props, option, { selected }) => {
                    const translatedOption =
                      option === "detailed"
                        ? "Detalhado"
                        : option === "compact"
                          ? "Compacto"
                          : option === "simple"
                            ? "Simples"
                            : option === "automatic"
                              ? "Automático"
                              : option;
                    return (
                      <li {...props} style={{ padding: "0px" }} key={option}>
                        <Tooltip
                          title={translatedOption}
                          placement="left-start"
                        >
                          <Stack sx={styles.stackOption}>
                            <Checkbox checked={selected} />
                            <span style={styles.textoLimitado}>
                              {translatedOption}
                            </span>
                          </Stack>
                        </Tooltip>
                      </li>
                    );
                  }}
                  id="combo-dsadbox-demo"
                  size="small"
                  color="primary"
                  options={["compact", "simple", "detailed", "automatic"]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Tipo de visualização"
                      error={requestSend && typeElementView == null}
                      helperText={
                        requestSend &&
                        typeElementView == null &&
                        "O tipo de visualização não pode ser nulo!"
                      }
                      color="primary"
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          startAdornment: (
                            <Box sx={{ mr: "-5px" }}>
                              <InputAdornment position="start">
                                <ViewQuilt
                                  sx={{
                                    color: theme.palette.color.bgIcon,
                                    fontSize: "20px",
                                  }}
                                />
                              </InputAdornment>
                            </Box>
                          ),
                        },
                      }}
                    />
                  )}
                />
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <PhotoSizeSelectLargeOutlined color="primary" />
                  <Typography sx={styles.text}>Tamanho do elemento</Typography>
                </Stack>
                <Autocomplete
                  key={"autocompleteNodeSize"}
                  value={nodeSize ?? 0}
                  onChange={(event, newValue) => {
                    const size = newValue ?? 0;
                    setNodeSize(size);
                    changeElement(element.id, {
                      nodeSize: size,
                    });
                    setCheckChanges(true);
                  }}
                  getOptionLabel={(option) => {
                    if (option === 0) return "Automático";
                    return option != null ? String(option) : "";
                  }}
                  ListboxComponent={VirtualizedListbox}
                  id="combo-nodesize-demo"
                  size="small"
                  color="primary"
                  options={[0, ...Array.from({ length: 50 }, (_, i) => i + 1)]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Tamanho do elemento"
                      color="primary"
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          startAdornment: (
                            <Box sx={{ mr: "-5px" }}>
                              <InputAdornment position="start">
                                <CropFree
                                  sx={{
                                    color: theme.palette.color.bgIcon,
                                    fontSize: "20px",
                                  }}
                                />
                              </InputAdornment>
                            </Box>
                          ),
                        },
                      }}
                    />
                  )}
                />
              </>
            )}
            {hasEnlace && !isShape && (
              <Stack sx={[styles.card, { p: 0.5, height: "50px" }]}>
                <Tabs
                  variant="fullWidth"
                  value={valueTab}
                  onChange={handleChangeTab}
                  textColor="primary"
                  indicatorColor="primary"
                  sx={styles.tabs}
                >
                  <Tab
                    sx={styles.text}
                    icon={valueTab == 0 ? <Link /> : null}
                    label="Conexões"
                    iconPosition={"start"}
                    value={0}
                  />
                  <Tab
                    icon={valueTab == 1 ? <Notes /> : null}
                    label="Descrição"
                    value={1}
                    sx={styles.text}
                    iconPosition={"start"}
                  />{" "}
                </Tabs>
              </Stack>
            )}
            {valueTab === 0 && !isShape && (
              <>
                <Stack
                  direction="row"
                  marginLeft={0.6}
                  gap={2}
                  alignItems="center"
                >
                  <LinkedIcon
                    style={{
                      fill: theme.palette.primary.main,
                      height: "22px",
                      width: "22px",
                    }}
                  />
                  <Typography sx={styles.text}>
                    Selecione a(s) conexão(ões)
                  </Typography>
                </Stack>
                {itensLoading && hostsConfig.length > 0 && (
                  <Skeleton variant="rounded" width="100%" height={50} />
                )}
                {!itensLoading && connectionsElement?.length > 0 && (
                  <Stack gap={1}>
                    {connectionsElement?.map((connection, index) => (
                      <NewCardConnection
                        key={`connection-${index}`}
                        index={index}
                        connection={connection}
                        onOpen={openLocalEnlace}
                        removeConexao={(id) =>
                          setOpenAlertModal({
                            open: true,
                            callback: removeConexao,
                            params: [id, "elemento"],
                            id,
                            severity: "warning",
                            tipo: "element",
                          })
                        }
                      />
                    ))}
                  </Stack>
                )}
                <Tooltip
                  title={
                    (hostsConfig?.length == 0 &&
                      "Nenhum host foi selecionado") ||
                    (itensHost?.length == 0 &&
                      "O host selecionado não contém itens de tráfico")
                  }
                  disableHoverListener={
                    !itensHost?.length == 0 || !hostsConfig?.length == 0
                  }
                >
                  <span>
                    <Button
                      disabled={itensHost?.length == 0}
                      sx={{
                        width: "150px",
                        color: theme.palette.color.text,
                        textTransform: "none",
                      }}
                      color="primary"
                      variant="text"
                      onClick={() => {
                        addConexao();
                      }}
                      startIcon={<AddOutlinedIcon />}
                    >
                      Nova conexão
                    </Button>
                  </span>
                </Tooltip>
              </>
            )}
            {valueTab === 1 && !isShape && (
              <>
                <Stack direction="row" gap={2} alignItems="center">
                  <>
                    <TextFields color="primary" />
                    <Typography sx={styles.text}>
                      Observações/Anotações do host
                    </Typography>
                  </>
                </Stack>
                <Stack direction="row" gap={1}>
                  <TextField
                    value={description || ""}
                    onChange={(e) => {
                      setCheckChanges(true);
                      setDescription(e.target.value);
                    }}
                    color="primary"
                    placeholder="Informe a observação"
                    variant="outlined"
                    size="small"
                    multiline
                    fullWidth
                    rows={3}
                    inputProps={{ maxLength: 255 }}
                  />
                </Stack>{" "}
              </>
            )}
          </Stack>{" "}
          <Stack
            direction="column"
            sx={{
              flex: 1,
              maxHeight: 60,
            }}
          >
            <Divider />
            <Stack
              direction="row"
              justifyContent={"space-around"}
              paddingTop={1.5}
            >
              {element?.id && (
                <Button
                  sx={styles.buttonBottom}
                  color="primary"
                  variant="text"
                  //endIcon={<DeleteOutline />}
                  startIcon={<DeleteOutline />}
                  onClick={() => {
                    deleteElementSocket(element.id);
                  }}
                >
                  {"Remover"}
                </Button>
              )}
              <Button
                sx={{
                  ...styles.buttonBottom,
                  color: theme.palette.text.disabled,
                }}
                variant="text"
                startIcon={<CancelOutlined />}
                onClick={() =>
                  checkChanges
                    ? setOpenAlertModal({
                        id: "unsavedChanges",
                        open: true,
                        severity: "warning",
                        text: "As alterações feitas não foram salvas. Se prosseguir com a operação as mudanças serão perdidas.",
                        callback: () => closeDrawer(),
                      })
                    : closeDrawer()
                }
              >
                {"Cancelar"}
              </Button>

              <Button
                disabled={itensLoading || !isValidate()}
                sx={[
                  styles.buttonBottom,
                  {
                    boxShadow: "none",
                    color: theme.palette.success.main,
                    backgroundColor: alpha(theme.palette.success.main, 0.2),
                    "&:hover": {
                      backgroundColor: alpha(theme.palette.success.main, 0.1),
                    },
                  },
                ]}
                variant="contained"
                startIcon={!element?.id ? <SaveOutlinedIcon /> : <Check />}
                onClick={() => {
                  element?.id ? updateElement() : createElement();
                  closeDrawer();
                }}
              >
                {element?.id ? "Atualizar" : "Adicionar"}
              </Button>
            </Stack>
          </Stack>
          <Popover
            open={Boolean(colorPickerAnchor)}
            anchorEl={colorPickerAnchor?.el}
            onClose={() => setColorPickerAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{
              paper: {
                sx: {
                  mt: 1,
                  borderRadius: "12px",
                  bgcolor: theme.palette.background.paper,
                  backgroundImage: "none",
                  overflow: "hidden",
                },
              },
            }}
          >
            <Stack sx={{ p: 1.5, width: 220 }} gap={1.5}>
              <HexAlphaColorPicker
                style={{ width: "100%" }}
                color={(() => {
                  const c =
                    colorPickerAnchor?.type === "background"
                      ? backgroundColor || "#ffffffff"
                      : colorPickerAnchor?.type === "polygonBorder"
                        ? polygonColor || theme.palette.secondary.main
                        : colorPickerAnchor?.type === "polygonFill"
                          ? fillColor ||
                            polygonColor ||
                            theme.palette.secondary.main
                          : textColor || "#000000ff";
                  return c.length === 7 ? c + "ff" : c;
                })()}
                onChange={(hex) => {
                  setCheckChanges(true);
                  if (colorPickerAnchor?.type === "background")
                    setBackgroundColor(hex);
                  else if (colorPickerAnchor?.type === "polygonBorder")
                    setPolygonColor(hex);
                  else if (colorPickerAnchor?.type === "polygonFill")
                    setFillColor(hex);
                  else setTextColor(hex);
                }}
              />
              <HexColorInput
                prefixed
                color={(() => {
                  const c =
                    colorPickerAnchor?.type === "background"
                      ? backgroundColor || "#ffffffff"
                      : colorPickerAnchor?.type === "polygonBorder"
                        ? polygonColor || theme.palette.secondary.main
                        : colorPickerAnchor?.type === "polygonFill"
                          ? fillColor ||
                            polygonColor ||
                            theme.palette.secondary.main
                          : textColor || "#000000ff";
                  return c.slice(0, 7);
                })()}
                onChange={(hex) => {
                  setCheckChanges(true);
                  const existing =
                    colorPickerAnchor?.type === "background"
                      ? backgroundColor
                      : colorPickerAnchor?.type === "polygonBorder"
                        ? polygonColor
                        : colorPickerAnchor?.type === "polygonFill"
                          ? fillColor
                          : textColor;
                  const alpha =
                    existing && existing.length === 9
                      ? existing.slice(7)
                      : "ff";
                  const next = hex + alpha;
                  if (colorPickerAnchor?.type === "background")
                    setBackgroundColor(next);
                  else if (colorPickerAnchor?.type === "polygonBorder")
                    setPolygonColor(next);
                  else if (colorPickerAnchor?.type === "polygonFill")
                    setFillColor(next);
                  else setTextColor(next);
                }}
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  background: alpha(theme.palette.text.primary, 0.06),
                  color: theme.palette.text.primary,
                  border: `1px solid ${alpha(theme.palette.text.primary, 0.15)}`,
                  borderRadius: 6,
                  padding: "6px 8px",
                  textTransform: "uppercase",
                  outline: "none",
                }}
              />
            </Stack>
          </Popover>
        </Drawer>

        {element && openEnlaceBar && (
          <EnlaceSideBarEasyMaps
            openEnlaceBar={openEnlaceBar}
            setOpenEnlaceBar={setOpenEnlaceBar}
            connection={editingConnection}
            setConnection={setEditingConnection}
            saveConnection={saveConnectionLocal}
            handleDelete={removeConexao}
            api={api}
            produtos={produtos}
            iconsElement={iconsElement}
            tipoMapa={tipoMapa}
            fullScreem={fullScreem}
            elementSelected={element}
            editingViaElement={true}
            loadRouting={loadRouting}
            setLoadRouting={setLoadRouting}
            autoRouting={autoRouting}
            cleanRouting={cleanRouting}
            setOpenAlertModal={setOpenAlertModal}
            changeConnection={changeConnection}
            hostsConfig={hostsConfig}
            typeElement={typeElement}
          />
        )}

        <ModalMap
          setOpen={setOpenModalMap}
          open={openModalMap}
          type={typeElement}
          api={api}
          addMapInMaps={addMapInMaps}
          selectMapRef={selectMapRef}
          setSnackbar={setSnackbar}
        />
      </>
    );
  },
);

export default CreationSliderBarEasyMaps;
